import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { FlexBox } from '../box';
import { withVersion } from '../utils';
import { Header } from './header';
import { TabHeader } from './tab-header';
export { isPageAction } from './header';
const PageImpl = React.forwardRef((props, ref) => {
    const { children, className, 'data-role': dataRole = 'page', 'data-role-value': dataRoleValue } = props;
    return (_jsx(FlexBox, { ref: ref, className: className, "data-role": dataRole, "data-role-value": dataRoleValue, stack: true, gap: 2, stretch: true, autoShrink: true, px: 3, pb: 3, children: children }));
});
PageImpl.displayName = 'Page';
PageImpl.Header = Header;
PageImpl.TabHeader = TabHeader;
export const Page = withVersion(PageImpl, '1.0.0');
